/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const demandProposedItemSchema = z.object({
  demandId: z.int(),
  id: z.int(),
  itemTypeId: z.int().nullish(),
  materialisedItemId: z.int().nullish(),
  parentId: z.int().nullish(),
  sortOrder: z.int(),
  title: z.string(),
});
